import { Logo, Logos } from "./Logos.tsx";
import { Section } from "./Section.tsx";

export const LeadingPartners = () => {
  return (
    <Section data-leading-partner>
      <h2>Access to industry-leading partners.</h2>

      <Logos>
        <Logo id="avaya" />
        <Logo id="Intelisys" />
        <Logo id="Microsoft" />
        <Logo id="Cisco" />
        <Logo id="Genesys" />
        <Logo id="N" />
        <Logo id="II" />
        <Logo id="five9" />
        <Logo id="Nice" />
        <Logo id="Ooma" />
        <Logo id="RingCentral" />
        <Logo id="Lumen" />
      </Logos>

      <a href="/partners" class="partners-see-all">See all 200+ partners →</a>
    </Section>
  );
};
